import React from "react";
const Colours = () => {
    return (

        <div id={"colours"}>
            <h3>Colours</h3>
            <p>
                Use Colour blocks to style different aspects of your Snap app. Colours can be chosen
                from a colour palette or specified as an RGB value between 0 and 255. For more information on
                colour values, please visit <a href="https://htmlcolorcodes.com/color-picker/">this link</a>.
                <div className={'imageContainer'}>
                    <img src="/images/colours.png" alt="Colours" />
                </div>
            </p>
        </div>
    );
}

export default Colours; 
